// extracted by mini-css-extract-plugin
module.exports = {"root":"Loading_root__3W4K5","page":"Loading_page__2LUu_"};